'use client';

import React from 'react'
import { useInView } from '@/lib/useInView'

interface HeadingProps {
  title?: string
  body?: string
  showTitle?: boolean
  showHr?: boolean
  className?: string
  disableAnimation?: boolean
}

export default function Heading({ title, body, showTitle = true, showHr = true, className = "", disableAnimation = false }: HeadingProps) {
  const { ref } = useInView<HTMLDivElement>();
  
  return (
    <>
      <div ref={disableAnimation ? undefined : ref} className={`heading mx-auto ${!disableAnimation ? 'animate-in-view' : ''} ${className}`}>
        {showTitle && title && <h2 className="heading-2">{title}</h2>}
        {body && <h3 className="body-xl-display mb-24" dangerouslySetInnerHTML={{ __html: body }} />}
        {showHr && <hr className="lg:mt-6 mt-[19px] border-black" />}
      </div>
    </>
  )
}
